(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProyectosPorPeriodoController', ProyectosPorPeriodoController);

    ProyectosPorPeriodoController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function ProyectosPorPeriodoController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedSSPeriodo = sSPeriodos[0];
        });        
        vm.sSAmbitos = sSAmbitos;
        vm.centrosDocentes = centrosDocentes;
        vm.programasEducativos = programasEducativos;
    	vm.sSEstatusProyecto = sSEstatusProyecto;       	
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.proyectosPorPeriodo(
                    vm.selectedSSPeriodo.id
                ).then(function () {
                	console.log("DONE");
                }).catch(function () {
                });
        }
    }
})();
